/**
 *
 * 2017
 * Development by Jeroen Braspenning
 *
 * --
 *
 * Little explanation about the project setup.
 *
 * The whole system us based around the AppCore and AppSandbox and AppComponents.
 * A loose implementation of https://addyosmani.com/largescalejavascript/
 *
 * ## AppComponent
 * These are stored in the js/components folder and initialize themself by calling a method on the AppCore.
 * Each component contains a name, selector and callback function. The selector is used to apply the component logic to
 * all the elements matching the selector.
 *
 * Components communicatie with eachother using the PubSub pattern. The components are loose coupled.
 *
 *
 * ## AppSandbox
 * Each component gets a copy of the AppSandbox, through this sandbox the component is able to access core functionality
 * like subscribing to a PubSub etc.
 *
 *
 * ## AppCore
 * Takes care of handling the registering and unregistering, initializing and uninitializing of components. But also
 * subscribing and publishing.
 *
 */

 /**
 * Vendor
 */
require('./vendor/picturefill.min')
require('./vendor/polyfill-classList')
require('./vendor/requestanimationframe')

require('./vendor/jquery');

// require('./vendor/flexibility') // ie10 flexbox polyfill

//const ObjectFitImages = require('./vendor/ofi')
const AppCore = require('./modules/module-app-core')
const Helpers = require('./helpers')
const FingerPrint2 = require('fingerprintjs2');
/**
* Initialize the AppCore and se t some basics
*/

let app = new AppCore()


/**
* Components
*/


const wallpaper1= require('./components/wallpaper')(app)

const navigation = require('./components/navigation')(app)
const welcome = require('./components/welcome-overlay')(app)
const vote = require('./components/vote')(app)
const overlay = require('./components/overlay')(app)
const vote_form = require('./components/vote-form')(app)
const avatar = require('./components/avatar')(app)
// const avatar_small = require('./components/avatar-small')(app)

const navigation_link = require('./components/navigation-link')(app)
const overlay_autoclose = require('./components/overlay-autoclose')(app)
const cookie_bar = require('./components/cookie-bar')(app)
const custom_dropdown = require('./components/custom-dropdown')(app)
const slider = require('./components/slider')(app)
const fileUpload = require('./components/file-upload')(app)


/**
* Init
* --------------------------------------
* this gets called by the body of the html
*/
window.init = function () {
  // IE version
  if (Helpers.getMSIEVersion() > -1 || Helpers.getTridentVersion() > -1) {
    document.documentElement.className += ' is-ie ie-version-' + Helpers.getMSIEVersion()
  }

  app.init()



  // generate a fingerprint, used for voting.
  new FingerPrint2().get(function(result, components){

    app.session = {
      fingerPrint:result
    }
});


  // custom bit for the dropdown to remain working after form reload
  jQuery(document).on('gform_post_render', function(event, formId) {
    app.deInitializeComponent('custom-dropdown')
    app.deInitializeComponent('file-upload')
      app.initializeComponent('custom-dropdown')
      app.initializeComponent('file-upload')

  });

  // gform.addFilter('gform_post_render', ()=> {
  //   console.log('nah');
  // })

}


// setTimeout(() => {
//   const iframe = document.querySelector('#player iframe');
//   var player = new YT.Player(iframe, {

//     events: {
//       'onReady': (event) => {
//           console.log(event.target)
//         // console.log()
//         setTimeout(() => {
//           event.target.playVideo()

//           setTimeout(() => {
//             console.log("aa")
//             event.target.playVideo()
//           }, 1500);
//         }, 3880);
//       }
//     }

//   });


//   // setTimeout(() => {
//   //   player.playVideo();
//   //   setTimeout(() => {
//   //     player.playVideo();
//   //   },1000);
//   // },10000);
//   // console.log(player);

// }, 3000);


// WEBPACK FOOTER //
// ./assets/js/app.js